import { useState } from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../components/Layout';
import PageBanner from '../components/Banner';

const RejoignezNous = () => {
  const [formStatus, setFormStatus] = useState({
    isSubmitting: false,
    isSuccess: false,
    error: null
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ ...formStatus, isSubmitting: true });
    setTimeout(() => {
      setFormStatus({
        isSubmitting: false,
        isSuccess: true,
        error: null
      });
      setTimeout(() => setFormStatus({
        isSubmitting: false,
        isSuccess: false,
        error: null
      }), 3000);
    }, 1000);
  };

  return (
    <Layout>
      <Helmet>
        <title>Rejoignez-nous - Aydees | Contactez notre Équipe</title>
        <meta name="description" content="Contactez l'équipe Aydees pour vos projets IT, partenariats ou opportunités. Nous sommes à votre écoute au Niger." />
        <meta name="keywords" content="rejoindre Aydees, contact, partenariat, opportunités, équipe, Niger" />
      </Helmet>
      
      <PageBanner 
        title="Rejoignez-nous" 
        subtitle="Nous sommes ravis de vous accueillir. Remplissez le formulaire ci-dessous pour nous contacter."
      />
      
      <div className="min-h-screen bg-gray-50 relative">
        {/* Motifs de fond technologiques */}
        <div className="absolute inset-0 overflow-hidden">
          {/* Grille */}
          <div className="absolute inset-0 bg-[linear-gradient(#20202010_1px,transparent_1px),linear-gradient(to_right,#20202010_1px,transparent_1px)] bg-[size:40px_40px]"></div>
          {/* Cercles décoratifs */}
          <div className="absolute top-20 left-10 w-72 h-72 bg-orange-500/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
        </div>

        {/* Contenu principal */}
        <div className="relative flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-8 w-full max-w-3xl">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-bold text-gray-700 mb-2">
                  Prénom & Nom
                </label>
                <input
                  required
                  type="text"
                  id="name"
                  className="w-full px-4 py-3 rounded-lg bg-white/50 border-2 border-gray-200 focus:bg-white focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-300"
                  placeholder="Entrez votre nom complet"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-bold text-gray-700 mb-2">
                  E-Mail
                </label>
                <input
                  required
                  type="email"
                  id="email"
                  className="w-full px-4 py-3 rounded-lg bg-white/50 border-2 border-gray-200 focus:bg-white focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-300"
                  placeholder="Entrez votre adresse email"
                />
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-bold text-gray-700 mb-2">
                  Objet
                </label>
                <input
                  required
                  type="text"
                  id="subject"
                  className="w-full px-4 py-3 rounded-lg bg-white/50 border-2 border-gray-200 focus:bg-white focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-300"
                  placeholder="Sujet de votre message"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-bold text-gray-700 mb-2">
                  Message
                </label>
                <textarea
                  required
                  id="message"
                  rows="6"
                  className="w-full px-4 py-3 rounded-lg bg-white/50 border-2 border-gray-200 focus:bg-white focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-300 resize-none"
                  placeholder="Écrivez votre message ici..."
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={formStatus.isSubmitting}
                className={`w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-4 rounded-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 flex items-center justify-center group font-bold text-sm uppercase tracking-wide
                  ${formStatus.isSubmitting ? 'opacity-75 cursor-not-allowed' : 'transform hover:-translate-y-0.5'}
                `}
              >
                {formStatus.isSubmitting ? (
                  <span className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    Envoi en cours...
                  </span>
                ) : (
                  <span className="flex items-center">
                    Envoyer le message
                    <svg 
                      className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </span>
                )}
              </button>

              {formStatus.isSuccess && (
                <div className="p-3 bg-green-50 border border-green-200 text-green-700 rounded-lg flex items-center text-sm font-medium">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  Message envoyé avec succès !
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RejoignezNous;